module.exports = __webpack_public_path__ + "img/Flag_of_Lebanon.db1d8d65.svg";